import { ViewController } from '@estee/elc-service';
import { action, observable } from 'mobx';
import { StoresRepository } from '../repositories/StoresRepository';

export class ServiceViewWithModalViewController extends ViewController {
    @observable public isServiceLocatorOverlayVisible: boolean = false;
    @observable public storeRepository: StoresRepository;

    @action
    public onExportedServiceViewWithModalClicked = () => {
        this.isServiceLocatorOverlayVisible = true;
    };

    @action
    public onCloseStoreLocatorOverlay = () => {
        this.isServiceLocatorOverlayVisible = false;
        //TODO: check for regression
        // this.storeRepository.stores = [];
    };
}
